<template>
    <b-modal @shown="onModalShown" id="edit-colaborador" @hidden="onModalHidden" no-close-on-esc no-close-on-backdrop
        hide-header hide-footer centered v-model="showModal" size="lg">
        <div class="modal-spinner" v-if="loading">
            <b-spinner />
        </div>

        <div v-if="!loading" class="d-flex flex-column my-2">
            <h2 class="mb-1">Editar colaborador</h2>
            <CustomAlert v-if="!loading" class="mb-1" variant="warning" :show="alertShouldShow"
                message="Você não tem autorização para editar este colaborador" />
            <validation-observer ref="colaboradorRules">
                <b-form class="my-2">
                    <b-row>
                        <b-col lg="4" md="4" sm="4">
                            <b-form-group label="CPF*">
                                <validation-provider #default="{ errors }" name="cpf" rules="required">
                                    <b-form-input :state="errors.length > 0 ||
                                        form.errorApi.cpf ||
                                        form.errorApi.error
                                        ? false
                                        : null
                                        " id="cpf-input" v-model="form.cpf" v-mask="'###.###.###-##'"
                                        placeholder="000.000.000-00" maxLength="14" :disabled="true" />
                                    <small v-if="errors[0]" class="text-danger">
                                        Este campo é de preenchimento obrigatório.
                                    </small>
                                    <small v-if="form.errorApi.cpf" class="text-danger">
                                        {{ form.errorApi.cpf }}
                                    </small>
                                    <small v-if="form.errorApi.error" class="text-danger">
                                        {{ form.errorApi.error }}
                                    </small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col lg="4" md="4" sm="4">
                            <b-form-group label="Data de nascimento*">
                                <validation-provider #default="{ errors }" name="data_nascimento" rules="required">
                                    <b-input-group>
                                        <vue-cleave id="data-nascimento-input" v-model="input.data_nascimento"
                                            :raw="false" :options="option.data" class="form-control"
                                            placeholder="00/00/0000" name="data_nascimento" autocomplete="off"
                                            :disabled="!editavel" @input="setNascimentoInput" />
                                        <b-input-group-append>
                                            <b-form-datepicker locale="pt-BR" button-only right :hide-header="true"
                                                v-model="form.data_nascimento" :max="today"
                                                class="form-control d-flex align-items-center"
                                                label-help="Selecione a data de nascimento" button-variant="custom-blue"
                                                clearable :disabled="!editavel" @input="setNascimentoPicker" />
                                        </b-input-group-append>
                                    </b-input-group>

                                    <small v-if="errors[0]" class="text-danger">
                                        Este campo é de preenchimento obrigatório.
                                    </small>
                                    <small v-if="form.errorApi.data_nascimento" class="text-danger">
                                        {{ form.errorApi.data_nascimento }}
                                    </small>
                                    <small v-if="form.errorApi.error" class="text-danger">
                                        {{ form.errorApi.error }}
                                    </small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col lg="4" md="4" sm="4">
                            <b-form-group label="Nome completo do colaborador*">
                                <validation-provider #default="{ errors }" name="nome" rules="required">
                                    <b-form-input :state="errors.length > 0 ||
                                        form.errorApi.nome ||
                                        form.errorApi.error
                                        ? false
                                        : null
                                        " id="nome-input" v-model="form.nome" placeholder="John Doe"
                                        :disabled="!editavel" />
                                    <small v-if="errors[0]" class="text-danger">
                                        Este campo é de preenchimento obrigatório.
                                    </small>
                                    <small v-if="form.errorApi.nome" class="text-danger">
                                        {{ form.errorApi.nome }}
                                    </small>
                                    <small v-if="form.errorApi.error" class="text-danger">
                                        {{ form.errorApi.error }}
                                    </small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="4" md="4" sm="4">
                            <b-form-group label="Nome da mãe">
                                <validation-provider #default="{ errors }" name="nome_mae">
                                    <b-form-input :state="errors.length > 0 || form.errorApi.nome_mae
                                        ? false
                                        : null
                                        " id="nome_mae-input" v-model="form.nome_mae" :disabled="!editavel"
                                        placeholder="Nome da mãe" />
                                    <small v-if="form.errorApi.nome_mae" class="text-danger">
                                        {{ form.errorApi.nome_mae }}
                                    </small>
                                    <small v-if="form.errorApi.error" class="text-danger">
                                        {{ form.errorApi.error }}
                                    </small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col lg="4" md="4" sm="4">
                            <validation-provider #default="{ errors }" name="genero" rules="required">
                                <b-form-group label="Sexo*" :state="errors.length > 0 || form.errorApi.genero ? false : null
                                    ">
                                    <v-select id="genero" v-model="form.genero" :options="generoSelect" label="topico"
                                        :disabled="!editavel" placeholder="Selecione uma opção" :clearable="true" />
                                    <small v-if="errors[0]" class="text-danger">
                                        Este campo é de preenchimento obrigatório.
                                    </small>
                                    <small v-if="form.errorApi.genero" class="text-danger">
                                        {{ form.errorApi.genero }}
                                    </small>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col lg="4" md="4" sm="4">
                            <validation-provider name="categoria" rules="required" #default="{ errors }">
                                <b-form-group label="Categoria*" :state="errors.length > 0 || form.errorApi.categoria
                                    ? false
                                    : null
                                    ">
                                    <v-select id="categoria" v-model="form.categoria" :options="categoriaSelect"
                                        label="descricao" :clearable="true" :disabled="!editavel"
                                        placeholder="Selecione uma categoria"
                                        @input="(selected) => form.id_categoria = selected ? selected.id_categoria : null" />
                                    <small v-if="errors[0]" class="text-danger">
                                        Este campo é de preenchimento obrigatório.
                                    </small>
                                    <small v-if="form.errorApi.id_categoria" class="text-danger">
                                        {{ form.errorApi.id_categoria }}
                                    </small>
                                    <small v-if="form.errorApi.error" class="text-danger">
                                        {{ form.errorApi.error }}
                                    </small>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="4" md="4" sm="4">
                            <NacionalidadeField :idNacionalidade="form.id_nacionalidade"
                                @updateNacionalidade="updateNacionalidade"
                                :errorApiIdNacionalidade="form.errorApi.id_nacionalidade"
                                customClass="edit-colaborador" />
                        </b-col>
                        <b-col lg="4" md="4" sm="4">
                            <b-form-group label="Matrícula">
                                <validation-provider #default="{ errors }" name="matricula">
                                    <b-form-input :state="errors.length > 0 ||
                                        form.errorApi.matricula ||
                                        form.errorApi.error
                                        ? false
                                        : null
                                        " id="matricula-input" v-model="form.matricula"
                                        placeholder="Identificação interna" />
                                    <small v-if="form.errorApi.matricula" class="text-danger">
                                        {{ form.errorApi.matricula }}
                                    </small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col lg="4" md="4" sm="4">
                            <b-form-group label="Setor">
                                <validation-provider #default="{ errors }" name="setor">
                                    <b-form-input :state="errors.length > 0 ||
                                        form.errorApi.setor ||
                                        form.errorApi.error
                                        ? false
                                        : null
                                        " id="setor-input" v-model="form.setor"
                                        placeholder="Área, setor ou departamento" />
                                    <small v-if="form.errorApi.setor" class="text-danger">
                                        {{ form.errorApi.setor }}
                                    </small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-form>
            </validation-observer>
        </div>
        <section v-if="!loading" class="d-flex justify-content-center mb-1">
            <b-button id="save-colaborador" class="mr-2 mb-2-sm" variant="custom-blue" @click.prevent="validationForm"
                :disabled="saving || !editavel">
                <feather-icon icon="CheckIcon" class="mr-50" />
                <span class="align-middle">Editar colaborador</span>
                <output v-if="saving" class="spinner-border spinner-border-sm ml-1"></output>
            </b-button>
            <b-button id="cancel-lote" :disabled="saving" variant="outline-danger" @click.prevent="cancelAction">
                <feather-icon icon="XIcon" class="mr-50" />
                <span class="align-middle">Descartar</span>
            </b-button>
        </section>
    </b-modal>
</template>

<script>
import {
    BModal,
    BForm,
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    VBTooltip,
    BSpinner,
    BCard,
    BFormDatepicker,
    BInputGroup,
    BInputGroupAppend,
    BAlert,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import CustomAlert from "@/views/components/custom/timed-alert/CustomAlert.vue";
import NacionalidadeField from "@/views/components/custom/field-select-nacionalidade/NacionalidadeField.vue";
import VueCleave from "vue-cleave-component";
import { required } from "@validations";
import { actions, subjects } from "@/libs/acl/rules";
import moment from "moment";
import vSelect from "vue-select";

export default {
    components: {
        BModal,
        BForm,
        BCol,
        BRow,
        BFormGroup,
        BFormInput,
        BButton,
        BTable,
        VBTooltip,
        BSpinner,
        BCard,
        vSelect,
        BFormDatepicker,
        BInputGroup,
        BInputGroupAppend,
        ValidationProvider,
        ValidationObserver,
        VueCleave,
        BAlert,
        NacionalidadeField,
        CustomAlert
    },
    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
        cleanModal: {
            type: Boolean,
            default: false,
        },
        colaborador: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            required,
            saving: false,
            loading: false,
            alertShouldShow: false,
            today: moment().format("YYYY-MM-DD"),
            option: {
                data: {
                    date: true,
                    delimiter: "/",
                    datePattern: ["d", "m", "Y"],
                },
                cpf: {
                    numericOnly: true,
                    uppercase: true,
                    delimiters: [".", ".", "-"],
                    blocks: [3, 3, 3, 2],
                },
            },
            form: {
                id_pessoa_fisica: null,
                id_nacionalidade: null,
                id_categoria: null,
                id_empresa: null,
                cpf: "",
                nome: "",
                genero: "",
                data_nascimento: "",
                categoria: "",
                ano: "",
                setor: "",
                matricula: "",
                nome_mae: "",
                errorApi: {
                    cpf: "",
                    nome: "",
                    genero: "",
                    data_nascimento: "",
                    id_categoria: "",
                    setor: "",
                    matricula: "",
                    error: "",
                    nome_mae: "",
                    id_nacionalidade: "",
                },
            },
            input: {
                data_nascimento: "",
            },
            generoSelect: [],
            categoriaSelect: [],
            editavel: false,
            canManageColab: false
        };
    },
    methods: {
        onModalShown() {
            this.cleanForm();

            this.loading = true;

            this.canManageColab = this.$can(
            actions.GERENCIAR,
            subjects.COLABORADOR_MENUS_ROTAS
        );

            this.editavel = !this.colaborador.colaborador.vacinado && this.colaborador.colaborador.editavel && this.colaborador.pode_gerenciar_colaboradores && this.canManageColab;

            this.$http.get(this.$api.getEmpresaCategoria()).then(({ data }) => {
                this.categoriaSelect = data;
            });

            this.generoSelect = ["Masculino", "Feminino"];
            this.preenchimentoFormulario(this.colaborador);

            this.$nextTick(() => {
                this.alertShouldShow = !this.editavel;
                this.loading = false;
            });
        },

        onModalHidden() {
            this.alertShouldShow = false;
        },

        validationForm() {
            this.saving = true;

            this.$refs.colaboradorRules.validate().then((success) => {
                if (success) {
                    this.editColaborador();
                }
            });

            this.saving = false;
        },

        editColaborador() {
            const parameters = {
                id_empresa: this.form.id_empresa,
                id_pessoa_fisica: this.form.id_pessoa_fisica,
                cpf: this.formatCpf(this.form.cpf),
                nome: this.form.nome,
                genero: this.form.genero,
                data_nascimento: this.form.data_nascimento,
                ano: this.form.ano,
                id_categoria: this.form.id_categoria,
                setor: this.form.setor,
                matricula: this.form.matricula,
                nome_mae: this.form.nome_mae,
                id_nacionalidade: this.form.id_nacionalidade,
            };

            this.$emit("confirmed", parameters);
        },

        cancelAction(modalEvent) {
            modalEvent.preventDefault();
            this.$emit("canceled", modalEvent);
        },

        preenchimentoFormulario(colaborador) {
            this.form.id_empresa = colaborador.empresa.id_empresa;
            this.form.id_pessoa_fisica = colaborador.colaborador.id_pessoa_fisica;
            this.form.id_categoria = colaborador.colaborador.id_categoria;
            this.form.id_nacionalidade = colaborador.colaborador.id_nacionalidade;

            this.form.cpf = colaborador.colaborador.cpf;
            this.form.nome = colaborador.colaborador.nome;
            this.form.genero = colaborador.colaborador.genero;

            this.form.data_nascimento = moment(
                colaborador.colaborador.data_nascimento,
                "DD/MM/YYYY"
            ).format("YYYY-MM-DD");
            
            this.form.categoria = colaborador.colaborador.categoria;
            this.form.ano = colaborador.colaborador.ano;
            this.form.matricula = colaborador.colaborador.matricula;
            this.form.setor = colaborador.colaborador.setor;
            this.form.nome_mae = colaborador.colaborador.nome_mae;
            this.form.descricao_nacionalidade = colaborador.colaborador.descricao_nacionalidade;

            this.setNascimentoPicker();
        },

        setNascimentoPicker() {
            this.input.data_nascimento = moment(this.form.data_nascimento, "YYYY-MM-DD").format("DD/MM/YYYY");
        },

        setNascimentoInput() {
            const parsed = moment(this.input.data_nascimento, "DD/MM/YYYY", true);
            this.form.data_nascimento = parsed.isValid()
                ? parsed.format("YYYY-MM-DD")
                : "";
        },

        updateNacionalidade(id_nacionalidade) {
            this.form.id_nacionalidade = id_nacionalidade;
        },

        formatCpf(cpf) {
            return cpf.replace(/\D/g, "");
        },

        cleanForm() {
            this.form.id_nacionalidade = null;
            this.form.id_pessoa_fisica = null;
            this.form.id_empresa = null;
            this.form.id_categoria = null;

            this.form.cpf = "";
            this.form.nome = "";
            this.form.genero = "";
            this.form.data_nascimento = "";
            this.input.data_nascimento = "";
            this.form.categoria = "";
            this.form.nome_mae = "";
            this.form.descricao_nacionalidade = "";
            this.form.ano = "";
            this.form.matricula = "";
            this.form.setor = "";

            this.form.errorApi.cpf = "";
            this.form.errorApi.nome = "";
            this.form.errorApi.genero = "";
            this.form.errorApi.data_nascimento = "";
            this.form.errorApi.id_categoria = "";
            this.form.errorApi.matricula = "";
            this.form.errorApi.setor = "";

            this.ediavel = false;

            this.$refs.colaboradorRules.reset();
        },
    },

    watch: {
        cleanModal(value) {
            if (value) {
                this.cleanForm();
            }
        },
    },
};

</script>

<style scoped>
.bloco {
    height: 200px;
}

.list-enter-active,
.list-leave-active {
    transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
    opacity: 0;
    transform: translateX(30px);
}

.panel-enter-active,
.panel-leave-active {
    transition: all 0.5s ease;
}

.panel-enter-from,
.panel-leave-to {
    opacity: 0;
    height: 0;
    transform: translateX(30px);
}

.modal-spinner {
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
